<template>
  <div>
    <div class="container-fluid mt-5" >
        <div class="vx-row">
            <div class="vx-col w-full">
                <vx-card>
                    <h3 class="mt-2">Cartera vencida instaladores {{statsDate}}</h3>
                    <div class="skinny row">
                      <div class="col-md-12 mb-3">
                        <label class="mt-1">Ingresa un id de proveedor y presiona el botón consultar si deseas buscar un proveedor en específico.</label>
                      </div>
                      <div class="col-md-2">
                        <label>ID de proveedor</label>
                        <vs-input type="number" class="w-full" icon-pack="feather" icon="icon-user" placeholder="Escribe un ID..." v-model="searchSupplierId" />
                      </div>
                      <div class="col-md-4">
                        <div class="flex flex-wrap mt-6">
                          <vs-button color="dark" @click="getSuppliersData(searchSupplierId)" :disabled="searchSupplierId <= 0">Consultar</vs-button>
                          <vs-button class="ml-1" color="success" @click="getSuppliersData('all')">Mostrar Todos</vs-button>
                        </div>
                      </div>
                    </div>
                    <div class="skinny row">
                      <div class="col-md-12 mb-3">
                        <vs-table
                        ref="suppliersTable"
                        stripe
                        pagination
                        :max-items="25"
                        class="mt-6"
                        :data="suppliers"
                        noDataText="No hay datos disponibles"
                        >
                        <template slot="thead">
                        <vs-th
                            class="bold"
                            v-for="(col, idx) in columns"
                            v-bind:key="idx"
                            :sort-key="col.sortable ? col.key : null"
                        >{{col.title}}</vs-th>
                        </template>
                        <template slot-scope="{ data }">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                              <vs-td>{{ tr.supplier_id }}</vs-td>
                              <vs-td>{{ tr.supplier_tradename }}</vs-td>
                              <vs-td><vs-button radius color="success" icon-pack="feather" icon="icon-bar-chart-2" v-on:click="showModalSupplier(tr.supplier_id)"></vs-button></vs-td>
                              <vs-td><strong>({{tr.projects_funded_number}})</strong> {{ explicitMoneyFormat(tr.projects_funded_amount)}}</vs-td>
                              <vs-td>
                                <div class="flex">
                                  <vs-button :disabled="tr.projects_funded_fall_due_number == 0" size="small" color="dark" icon-pack="feather" icon="icon-eye" v-on:click="showModalSupplierProjects(tr)"></vs-button>
                                  <span class="ml-2 mt-1" ><strong>({{tr.projects_funded_fall_due_number}})</strong> {{ explicitMoneyFormat(tr.projects_funded_fall_due_amount) }}</span>
                                </div>
                              </vs-td>
                              <vs-td><small class="pill-success">{{ decimalPercentFormat(tr.projects_funded_fall_due_number/tr.projects_funded_number) }}</small></vs-td>
                              <vs-td><small class="pill-danger">{{ decimalPercentFormat(tr.projects_funded_fall_due_amount/tr.projects_funded_amount) }}</small></vs-td>
                            </vs-tr>
                        </template>
                        </vs-table>
                      </div>
                    </div>
                </vx-card>
            </div>
        </div>

        <!-- LISTADO DE IDS DE PROYECTOS DEL INSTALADOR -->
        <vs-popup :title="'Listado de proyectos del instalador (SID: '+selectedSupplierId+')'" :active.sync="showModalProjects">
          <div class="vx-row">
            <!-- <div class="vx-col w-full md:w-1/2">
              <vs-list>
                <vs-list-header title="Proyectos fondeados"></vs-list-header>
                <vs-list-item  v-for="(project, index) in selectedSupplierFundedProjectsIds" :title="'PID: '+project" v-bind:key="index">
                  <vs-button color="success" size="small" icon-pack="feather" icon="icon-eye" :href="$sanitizeUrl('/cobranza/' + project)" target="blank"></vs-button>
                </vs-list-item>
              </vs-list>
            </div> -->
            <div class="vx-col w-full">
              <vs-list>
                <vs-list-header title="Proyectos vencidos" color="danger"></vs-list-header>
                <vs-list-item  v-for="(project, index) in selectedSupplierExpiredProjectsIds" :title="'PID: '+project" v-bind:key="index">
                  <vs-button color="dark" size="small" icon-pack="feather" icon="icon-eye" :href="$sanitizeUrl('/cobranza/' + project)" target="blank"></vs-button>
                </vs-list-item>
              </vs-list>
            </div>
          </div>
        </vs-popup>

        <!-- HISTORIAL DE LA CARTERA VENCIDA DE UN INSTALADOR -->
        <vs-popup :title="'Cartera vencida del último año del instalador (SID: '+selectedSupplierId+')'" :active.sync="showModalStatistics">
          <historical-due-portfolio-supplier-stats v-if="showModalStatistics" ref="historicalDuePortfolioSupplierStats" :supplierId="selectedSupplierId" />
        </vs-popup>
    </div>
  </div>
</template>

<script lang="js">
  import dateHelper from "@mixins/dateHelper";
  import formatHelper from '@components/mixins/formatHelper';
  import HistoricalDuePortfolioSupplierStats from "@components/supplier/HistoricalDuePortfolioSupplierStats";
  
  const columnDefinitions = [
    { title: "SID", key: "supplier_id", sortable: true },
    { title: "INSTALADOR", key: "supplier_tradename", sortable: true },
    { title: "HISTORIAL", key: "id", sortable: false },
    { title: "PROYECTOS FONDEADOS", key: "projects_funded_amount", sortable: true },
    { title: "PROYECTOS VENCIDOS", key: "projects_funded_fall_due_amount", sortable: true },
    { title: "EN PROYECTOS", key: "projects_funded_fall_due_number", sortable: true },
    { title: "EN SALDO INSOLUTO", key: "projects_funded_fall_due_amount", sortable: true },
  ];

  export default  {
    name: 'DuePortfolioBySupplier',
    props: [],
    components: {
      HistoricalDuePortfolioSupplierStats
    },
    mixins: [dateHelper,formatHelper],
    async mounted() {
      await this.getSuppliersData("all");
    },
    data() {
      return {
        columns: columnDefinitions,
        suppliers: [],
        loading: false,
        searchSupplierId:null,
        showModalStatistics:false,
        showModalProjects:false,
        selectedSupplierId:null,
        statsDate:null,
        // selectedSupplierFundedProjectsIds: [],
        selectedSupplierExpiredProjectsIds: [],
      }
    },
    methods: {
      async getSuppliersData(option){
        this.showLoading(true);
        this.suppliers = [];
        this.statsDate = null;
        await axios.get('/api/suppliers/getLastDuePortfolioBySupplier/'+option).then(response => {
          this.suppliers = response.data;
          if(this.suppliers.length > 0){
            this.statsDate=this.regularDateFormat(this.suppliers[0].stats_date);
          }
          if(option==="all"){
            this.searchSupplierId=null;
          }
          this.showLoading(false);
        }).catch(error => {
          this.showLoading(false);
        });
      },
      showModalSupplier(id){
        this.selectedSupplierId = id;
        this.showModalStatistics = true;
      },
      showModalSupplierProjects(selectedSupplier){
        this.selectedSupplierId = selectedSupplier.supplier_id;
        // this.selectedSupplierFundedProjectsIds = selectedSupplier.projects_funded_ids != ""? selectedSupplier.projects_funded_ids.split(','):[];
        this.selectedSupplierExpiredProjectsIds = selectedSupplier.projects_funded_fall_due_ids != ""? selectedSupplier.projects_funded_fall_due_ids.split(','):[];
        this.showModalProjects = true;
      }
    }
}
</script>